import { render, staticRenderFns } from "./mdc-app.vue?vue&type=template&id=40a8fe12&scoped=true&"
import script from "./mdc-app.vue?vue&type=script&lang=ts&"
export * from "./mdc-app.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-app.vue?vue&type=style&index=0&id=40a8fe12&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8fe12",
  null
  
)

export default component.exports